import { render, staticRenderFns } from "./QuestionPage.vue?vue&type=template&id=562cb211&"
import script from "./QuestionPage.vue?vue&type=script&lang=js&"
export * from "./QuestionPage.vue?vue&type=script&lang=js&"
import style0 from "./QuestionPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "QuestionPage.vue"
export default component.exports